import React from 'react'
import {useMainLeaderBoardFilter} from '@hook/useLeaderBoardFilter'
import MainLeaderboardHeaderContainer from '@feature/leaderboard/pages/ScreenMain/MainLeaderboardHeaders/MainLeaderboardHeaderContainer'
import dynamic from 'next/dynamic'
import Spinner from '@component/Spinner/Spinner'

interface IProps {
    className?: string
}

const LeaderboardScreenMainTableContent = dynamic(
    import('@feature/leaderboard/pages/ScreenMain/LeaderboardScreenMainTableContent'),
    {
        ssr: false,
        loading: e => <Spinner visible={e?.isLoading} className={'mt-[30px] mx-auto'} />,
    },
)

const LeaderboardScreenMainTableContainer: React.FC<IProps> = ({className}) => {
    const {mainFilter} = useMainLeaderBoardFilter()
    const {sortBy} = mainFilter

    return (
        <div className={`${className}`} data-cy={'leaderboard_table_main'}>
            <MainLeaderboardHeaderContainer sortBy={sortBy} />
            <LeaderboardScreenMainTableContent mainFilter={mainFilter} />
        </div>
    )
}
export default LeaderboardScreenMainTableContainer
